/**
 * Returns a string to be used to create Block-Element-Modifier-style IDs for styles and clickable elements
 */
export const BEM_NAME_ELEMENTS = {
	VIEW_BREADCRUMBS: 'navigation-breadcrumbs',
	VIEW_NAVIGATION: 'navigation',
	VIEW_EDIT: 'edit-profile',
	VIEW_DELEGATE: 'delegate',
	VIEW_REASSIGN: 'reassign',
	VIEW_RENEW: 'renew',
	VIEW_REVIEW: 'review',
	VIEW_SUMMARY: 'summary',
	VIEW_TERMINATE: 'terminate',
	FIELD_ACCORDION: 'accordion',
	FIELD_BUTTON: 'button',
	FIELD_CHECKBOX: 'checkbox',
	FIELD_LINK: 'link',
	FIELD_LIST: 'list',
	FIELD_SELECT: 'select',
	FIELD_SPEED_DIAL: 'speed-dial',
	FIELD_SWITCH: 'switch',
	FIELD_TEXT_FIELD: 'textfield',
	SUBMIT: 'submit',
};
